import React from 'react';
import Row from '../Symbols/Row';
import Button from '../Symbols/Button';
import Input from '../Symbols/Input';
import Result from './Result';
import Form from '../Symbols/Form';
import Wrapper from '../Symbols/Wrapper';
import styled from '@emotion/styled';

const emptyFunc = () => {};

const InputSuffix = styled('span')`
	flex-basis: 10%;
	padding: 10px 0;
	line-height: 20px;
`;

export default props => {
	const {
		validateHandler = emptyFunc,
		changeHandler = emptyFunc,
		errors = {},
		state: { weight = 60, height = 170 },
		bmi = null,
		onSubmit,
		reset,
	} = props;

	return (
		<Wrapper>
			<Form onSubmit={onSubmit} title="Kalkulačka BMI">
				<Input
					type="number"
					label="Jaká je váše výška"
					onChange={changeHandler('height')}
					onBlur={validateHandler('height')}
					value={height}
					name="height"
					error={errors.height}
					passedProps={{ 'data-cy': 'height' }}
				>
					<InputSuffix>&nbsp;cm</InputSuffix>
				</Input>

				<Input
					type="number"
					label="Jaká je vaše váha"
					onChange={changeHandler('weight')}
					onBlur={validateHandler('weight')}
					value={weight}
					name="weight"
					error={errors.weight}
					passedProps={{ 'data-cy': 'weight' }}
				>
					<InputSuffix>&nbsp;kg</InputSuffix>
				</Input>

				<div css={Row}>
					<Button data-cy="submit">Výpočet</Button>
				</div>

				{bmi && <Result bmi={bmi} />}

				{bmi && (
					<div css={Row}>
						<Button onClick={reset} data-cy="reset">
							Nový výpočet
						</Button>
					</div>
				)}
			</Form>
		</Wrapper>
	);
};
